import { FormattedText } from "@tm/static";
import { useMemo } from "react";
import type { CancelPolicyPaymentDetailsData } from "../types";
import {
  PaymentBreakupItemRow,
  paymentBreakupLabelStyle,
  PaymentBreakupList,
  paymentBreakupValueStyle,
  PaymentDetailsHeader,
  PaymentSectionWrap,
  paymentTitleStyle,
  paymentTotalLabelStyle,
  PaymentTotalRow,
  paymentTotalValueStyle,
} from "./CancelPolicyPaymentDetails.style";
import { StepCard } from "./CancelPolicyStepCards.style";

export const CancelPolicyPaymentDetails = ({
  header,
  paymentInfo,
}: CancelPolicyPaymentDetailsData) => {
  const totalPaid = paymentInfo?.totalPaid;
  const breakup = useMemo(
    () =>
      (paymentInfo?.paymentBreakup ?? []).filter(
        (item) => item.sourceText || item.value
      ),
    [paymentInfo?.paymentBreakup]
  );

  const hasTotalPaid = totalPaid?.label || totalPaid?.value;

  if (!header) {
    return null;
  }

  return (
    <StepCard>
      {header.title ? (
        <PaymentDetailsHeader>
          <FormattedText value={header.title} baseStyle={paymentTitleStyle} />
        </PaymentDetailsHeader>
      ) : null}

      {hasTotalPaid || breakup.length > 0 ? (
        <PaymentSectionWrap>
          {hasTotalPaid ? (
            <PaymentTotalRow>
              <FormattedText
                value={totalPaid?.label}
                baseStyle={paymentTotalLabelStyle}
              />
              <FormattedText
                value={totalPaid?.value}
                baseStyle={paymentTotalValueStyle}
              />
            </PaymentTotalRow>
          ) : null}

          {breakup.length > 0 ? (
            <PaymentBreakupList>
              {breakup.map((item, index) => (
                <PaymentBreakupItemRow key={`breakup-${index}`}>
                  <FormattedText
                    value={item.sourceText}
                    baseStyle={paymentBreakupLabelStyle}
                  />
                  <FormattedText
                    value={item.value}
                    baseStyle={paymentBreakupValueStyle}
                  />
                </PaymentBreakupItemRow>
              ))}
            </PaymentBreakupList>
          ) : null}
        </PaymentSectionWrap>
      ) : null}
    </StepCard>
  );
};

export default CancelPolicyPaymentDetails;
